import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import Checkbox from '../components/elements/Checkbox';
import { useTranslation } from 'react-i18next';
import googleLogo from '../assets/googlelogo.png';
import '../styles/LoginModal.scss';
import ReCAPTCHA from 'react-google-recaptcha';

const LoginModal = ({
  setShowLoginModal,
  randomImages,
  randNumber,
  usermail,
  setUsermail,
  password,
  setPassword,
  handleSubmit,
  onGoogleClick,
  remember,
  setRemember,
  loginError,
  isLoading,
  isEmailNotVerified,
  handleResendVerification,
}) => {
  const [show, setShow] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const captchaRef = React.useRef(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

  return (
    <div className="login-overlay" onClick={() => setShowLoginModal(false)}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <div className="login-modal-left-side">
          <div className="login-modal-title">
            <p>{t('log-in.title')}</p>
          </div>
          <div className="login-modal-image">
            <img className="random-images" src={randomImages[randNumber]} alt="" />
          </div>
        </div>

        <div className="login-modal-right-side">
          <button className="login-modal-close-button" onClick={() => setShowLoginModal(false)}>
            <span className="material-icons-outlined">close</span>
          </button>

          <div className="login-modal-login-title">
            <p>{t('log-in.Sign in')}</p>
          </div>

          {loginError && (
            <div className="login-error-message">{t(loginError)}</div>
          )}
          {isEmailNotVerified && (
            <button
              type="button"
              className="login-resend-btn"
              onClick={handleResendVerification}
              disabled={isLoading}
            >
              Resend verification email
            </button>
          )}

          <div className="login-modal-input-container">
            <input
              type="email"
              className="login-input"
              placeholder={t('log-in.Email')}
              value={usermail}
              onChange={(e) => setUsermail(e.target.value)}
            />
          </div>

          <div className="login-modal-input-container">
            <div className="password-input-wrapper">
              <input
                type={show ? 'text' : 'password'}
                className="login-input"
                placeholder={t('log-in.Password')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="password-toggle" onClick={() => setShow(!show)}>
                {show
                  ? <BsEye style={{ cursor: 'pointer' }} />
                  : <BsEyeSlash style={{ cursor: 'pointer' }} />
                }
              </span>
            </div>
          </div>

          <div className="login-modal-checkbox-recovery-container">
            <Checkbox
              label={t('log-in.login-checkbox_label')}
              name="remember"
              value={remember}
              onChange={(e) => setRemember(e.target.checked)}
              checked={remember}
            />
            <div className="recovery-label">
              <Link
                to="/recover-password"
                onClick={() => {
                  setShowLoginModal(false);
                  setUsermail('');
                  setPassword('');
                  setRemember(false);
                }}>
                <p>{t('log-in.Recover password')}</p>
              </Link>
            </div>
          </div>

          <div className="recaptcha-container">
            <ReCAPTCHA
              ref={captchaRef}
              sitekey={siteKey}
              onChange={(value) => setCaptchaValue(value)}
              onExpired={() => {
                setCaptchaValue(null);
                captchaRef.current?.reset();
              }}
              onErrored={() => {
                setCaptchaValue(null);
                captchaRef.current?.reset();
              }}
            />
          </div>

          <div className="login-modal-buttons-column-container">
            <button
              disabled={isLoading || !captchaValue}
              className="login-local-button"
              onClick={() => handleSubmit()}>
              {isLoading ? <><span className="login-btn-spinner" /> {t('log-in.Sign in')}</> : t('log-in.Sign in')}
            </button>
            <div className="login-or-divider">
              <span />
              <p>or</p>
              <span />
            </div>
            <button
              className="login-google-button"
              onClick={() => {
                setShowLoginModal(true);
                setUsermail('');
                setPassword('');
                setRemember(true);
                onGoogleClick();
              }}>
              <img src={googleLogo} alt="" />
              <p>{t('log-in.Google-login')}</p>
            </button>
          </div>

          <div className="login-modal-register-container">
            <p className="new-user-label">{t('log-in.New user')}?</p>
            <p
              className="register-here-link"
              onClick={() => {
                setShowLoginModal(false);
                setUsermail('');
                setPassword('');
                setRemember(false);
                navigate('/user-registration');
              }}>
              {t('log-in.Register here')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;